//
// USEFUL ELEMENTS
//

import SosButton from '@/components/SosButton'
import SosSelect from '@/components/SosSelect'

//
// MAIN ELEMENTS / COMPONENTS
//

import SosDutiesCalendar from '@/components/SosDutiesCalendar'
import DetalhesDoPlantao from '@/modals/DetalhesDoPlantao'

//
// REPORTS
//

import ExportPayrollModal from '@/modals/reports/ExportPayrollModal'
import ExportScaleHoursModal from '@/modals/reports/ExportScaleHoursModal'
import ExportScaleModal from '@/modals/reports/ExportScaleModal'
import ExportOperationalReportModal from '@/modals/reports/ExportOperationalModal'

//
// VUE MIXINS
//

import scaleMixin from '@/mixins/scale.mixin.js'

//
// IMAGES / ASSETS
//

import userProfileBroken from '@/assets/images/user-profile-broken.png'
import userProfileCancelado from '@/assets/images/duty-status-cancelado.png'
import userProfileAvailable from '@/assets/images/duty-status-available.png'
import userProfileAvailableAndRequested from '@/assets/images/duty-status-available-and-requested.png'

//
// USEFUL FUNCTIONS TO HANDLING SHIFTS
//

import { isValidDuty, apiGetScaleDutiesRef, getShiftPause, isValidUserID, loadUsers } from '@/services/duties'
import { apiRefOpen, apiRefClose } from '@/services/firebase'

import { isShiftExpired, convertMonthNameToJavascriptMonthCode } from '@/functions'

import { hhmmToFloat, formatDbTime, durationToMinutes, formatFloatToScaleDuration, formatMoney, calculateEndTime } from '@/mixins/utils'

//
// CONSTANTS
//

import { GRUPO_CRIAR_ESCALA, GRUPO_ACOMPANHAR_ESCALA } from '@/constants'

//
// THIRD PARTY
//

import { mapState } from 'vuex'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import moment from 'moment'
import 'moment/locale/pt-br'
// moment.locale('pt-BR')

//
//
//

export default {
  name: 'ViewScale',

  components: {
    'sos-button': SosButton,
    'sos-select': SosSelect,

    'sos-duties-calendar': SosDutiesCalendar,
    'detalhes-do-plantao': DetalhesDoPlantao,
    'export-scale-modal': ExportScaleModal,
    'export-payroll-modal': ExportPayrollModal,
    'export-scale-hours-modal': ExportScaleHoursModal,
    'export-operational-report-modal': ExportOperationalReportModal,
    'date-picker': DatePicker,
  },

  mixins: [
    scaleMixin,
  ],

  data () {
    return {
      //

      userProfileBroken,
      userProfileAvailable,
      userProfileCancelado,

      hasPlantoes: 'loading',
      loadingMessage: 'Carregando informações do grupo...',

      showGoToTopButton: false,

      cachedUserProfiles: [],

      // scaleValue: '',
      showTurnModal: false,

      // goToFirst: false,

      dutiesByDateTime: {},
      dutiesShifts: [],

      reportHoras: [],

      weekStartCalendar: 'domingo',

      btnState: {
        relatorioHoras: false,
        folhaDePagamento: false,
        //
      },
      lastLoadedDuties: null,
    }
  },

  computed: {
    ...mapState({
      group: state => state.app.group,
      groupUsers: state => state.app.groupUsers,
      listeners: state => state.app.listeners,
      currentGroupCapabilities: state => state.app.currentGroupCapabilities,
    }),

    loadingGroupUsers() {
      return this.listeners.loadingGroupUsers
    },

    permissaoGrupoCriarEscala() {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_CRIAR_ESCALA] === true
    },

    permissaoGrupoAcompanharEscala() {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_ACOMPANHAR_ESCALA] === true
    },
  },

  watch: {
    startOnMonday: {
      handler (newVal, oldVal)
      {
        if (oldVal === 'waiting' && newVal !== 'waiting')
        {
          // [24/01/25] console.log('::: START ON MONDAY')

          //
          // CACHED FILTERS
          //

          let parsedFilters = null

          const filters = localStorage.getItem(`@sosplantao_viewscale_${this.$route.params.scaleID}`)

          if (!!filters === true) {
            try {
              parsedFilters = JSON.parse(filters)
            } catch (e) {
              localStorage.removeItem(`@sosplantao_viewscale_${this.$route.params.scaleID}`)
            }
          }

          if (!!parsedFilters === true) this.scaleZoom = parsedFilters.zoom

          //
          //
          //

          // CONSTRÓI O CALENDÁRIO APÓS RECONHECER QUAL O PRIMEIRO DIA DA SEMANA ESCOLHIDO PELOS GESTORES
          this.setYearMonthSetup(!!parsedFilters === true ? { month: parsedFilters.month, year: parsedFilters.year } : false)

          //
          //

          // Para não recarregar mês atual - SENHOR JESUS
          this.fbScaleDutiesRefYear = this.actualYear
          this.fbScaleDutiesRefMonth = this.actualMonth

          // INICIA CARREGAMENTO DOS PLANTÕES
          this.startDuties(this.actualMonth, this.actualYear)

          // APÓS ATUALIZAR A PÁGINA (Exemplo: F5) OS DETALHES DO GRUPO (E USUÁRIOS) SERÃO CARREGADOS.
          // ELES SÃO USADOS NA TELA AddUserToScaleModal
          this.$store.dispatch('loadGroupPage', this.localGroupID)
        }
      },
    },
    group: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        // Só executa quando o grupo termina de carregar
        if (oldVal && oldVal.loading && newVal && !newVal.loading) {
          // método que precisa dos dados do grupo carregados
          this.onGroupLoaded();
        }
      }
    },
  },

  // mounted
  async created ()
  {
    this.localGroupID = this.$route.params.groupID
    this.localScaleID = this.$route.params.scaleID

    // LOAD SCALE
    this.loadScale(this.localGroupID, this.localScaleID, 'view')

    // Carregar todos os usuários do grupo via Firebase
    await this.$store.dispatch('loadGroupUsersAll', this.localGroupID)

    // SCROLL
    window.addEventListener('scroll', this.handleScroll)
  },

  // destroyed () {
  beforeDestroy ()
  {
    // STOP SCALE LISTENER
    this.unloadScale()

    // STOP DUTIES LISTENER
    this.stopDuties()

    // STOP GO TO TOP SCROLLING LISTENER
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    //
    //

    handleScroll () {
      if (window.scrollY >= 300 && !this.showGoToTopButton) this.showGoToTopButton = true
      if (window.scrollY < 300 && this.showGoToTopButton) this.showGoToTopButton = false
    },

    toTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    //
    //

    setYearMonth (date, type)
    {
      if (date !== null)
      {
        const monthYear = date.split('/')
        const month = monthYear[0]
        const year = Number(monthYear[1])

        this.viewRebuildYearMonthWeek(month, year)

        //
        // CACHE
        //

        localStorage.setItem(`@sosplantao_viewscale_${this.$route.params.scaleID}`, JSON.stringify({ month, year, zoom: this.scaleZoom }))
      }
    },

    setZoom (zoom) {
      this.scaleZoom = zoom

      //
      // CACHE
      //

      localStorage.setItem(`@sosplantao_viewscale_${this.$route.params.scaleID}`, JSON.stringify({ month: this.actualMonth, year: this.actualYear, zoom }))
    },

    //
    //

    openRelatorioHorasDialog () {
      this.$refs.exportScaleHoursModal.open({ month: this.actualMonth, year: this.actualYear, shifts: this.reportHoras })
    },

    onScaleReportActionClick (action) {
      this.$refs.exportScaleModal.open({ format: action.id, currentMonth: Number(this.actualMonth) + 1, currentYear: this.actualYear, startOnMonday: this.startOnMonday })
    },

    exportPayroll () {
      this.$refs.exportPayrollModal.open(this.actualMonth, this.actualYear)
    },

    setButtonState (state) {
      this.btnState.relatorioHoras = state
    },

    setPayrollButtonState (state) {
      this.btnState.folhaDePagamento = state
    },

    openExportScaleHoursModal  () {
      this.btnState.operationalReport = true;
      try {
        this.$refs.exportOperationalReportModal.open({
          month: this.actualMonth,
          year: this.actualYear,
          groupID: this.localGroupID,
          scaleID: this.localScaleID,
        });
      } catch (error) {
        console.log('::: [DEBUG] Erro ao abrir relatório operacional:', error);
      } finally {
        this.btnState.operationalReport = false;
      }
    },

    //
    //

    viewRebuildYearMonthWeek (inputMonth, inputYear)
    {
      this.actualMonth = convertMonthNameToJavascriptMonthCode(inputMonth)
      this.actualYear = inputYear

      //
      //
      //

      this.preRebuildYearMonthWeek()
      // this.rebuildYearMonthWeek()

      if (this.actualYear !== this.fbScaleDutiesRefYear || this.actualMonth !== this.fbScaleDutiesRefMonth) {
        this.fbScaleDutiesRefYear = this.actualYear
        this.fbScaleDutiesRefMonth = this.actualMonth

        // STOP DUTIES
        this.stopDuties()

        // LOAD DUTIES
        this.startDuties(this.fbScaleDutiesRefMonth, this.fbScaleDutiesRefYear, true)
      }
    },

    //
    //

    openShift (shift) {
      const firstWeek = this.weeks[0]
      const lastWeek = this.weeks[this.weeks.length - 1]

      const firstDate = firstWeek.value[0].day
      const lastDate = lastWeek.value[6].day

      this.$refs.dutyModal.open(shift.plantaoID || '', firstDate, lastDate)
    },

    goBackToGroupScales () {
      this.$router.push(`/admin/grupos/${this.localGroupID}/escalas`)
    },

    goToEditScale () {
      this.$router.push(`/admin/grupos/${this.localGroupID}/escalas/${this.localScaleID}/editar`)
    },

    /**
     *
     * HANDLE DUTIES
     *
     */

    startDuties (month, year, prebuilt = false)
    {
      if (this.fbScaleDutiesRef !== null) return false

      this.hasPlantoes = 'loading' // SENHOR JESUS
      this.loadingMessage = `Carregando ${this.months[month]} de ${year}...`

      const firstWeek = prebuilt ? this.preLoadedWeeks[0] : this.weeks[0]
      const lastWeek = prebuilt ? this.preLoadedWeeks[this.preLoadedWeeks.length - 1] : this.weeks[this.weeks.length - 1]

      const firstDate = firstWeek.value[0].day
      const lastDate = lastWeek.value[6].day

      //
      // SENHOR JESUS
      // Confirmar se as datas estão no "padrão UTC" (é assim que diz?)
      //

      // console.log(`::: startDuties(${month}, ${year}):`, firstDate, lastDate)

      this.fbScaleDutiesRef = apiGetScaleDutiesRef(this.localScaleID, { type: 'viewscale', firstDate, lastDate })
      apiRefOpen(this.fbScaleDutiesRef, this.onDutiesUpdate)
    },

    stopDuties ()
    {
      if (this.fbScaleDutiesRef === null) return false
      apiRefClose(this.fbScaleDutiesRef, this.onDutiesUpdate)
      this.fbScaleDutiesRef = null
    },

    async onDutiesUpdate (loaded)
    {
      // Salve o último duties carregado para usar depois do grupo carregar
      this.lastLoadedDuties = loaded;

      // Só prossiga se o grupo já estiver carregado
      if (this.group && !this.group.loading) {
        const shiftsData = !!loaded === true && !!loaded.val() === true ? loaded.val() : {}
        const shifts = Object.entries(shiftsData).filter(([_, shift]) => isValidDuty(shift))
        const reportHoras = Object.values(shiftsData)

        this.reportHoras = reportHoras.length > 0 ? reportHoras : []

        this.dutiesShifts = []

        // JESUS: Qual o propósito?
        if (this.preLoadedWeeks.length > 0) this.weeks = this.preLoadedWeeks

        //
        //
        //

        if (shifts.length === 0)
        {
          this.dutiesByDateTime = {}
          this.hasPlantoes = 'no'

          return false
        }

        //
        // PROCESS DUTIES AND EXTRACT USERS AND SCALES TO BE LOADED AND CACHED LOCALLY
        //

        const filteredShifts = []

        const shiftsUsers = new Set()
        // const shiftsScales = new Set()

        //console.log('View scale shifits:', shifts);
        shifts.forEach(([plantaoID, shift]) => {
          // USEFUL DATA AND PREVENTION
          shift.plantaoID = plantaoID
          shift.uid_pegou = isValidUserID(shift.uid_pegou || '') ? String(shift.uid_pegou) : 0

          // IS EXPIRED
          shift.isExpired = isShiftExpired(shift.data_inicio, shift.hora_inicio, shift, 15)
          shift.isExpiredForReiciving = isShiftExpired(shift.data_inicio, shift.hora_inicio, shift)

          // VERIFICA SE O PLANTÃO ESTÁ AGUARDANDO SER ACEITO OU RECUSADO
          shift.isUserPassingThisShift = isValidUserID(shift.uid_pegando || '') && !shift.isExpiredForReiciving // Tratar expiração aqui?

          // SOLICITADO POR ALGUM USUÁRIO?
          shift.solicitado = !!shift && !!shift.candidates && typeof shift.candidates === 'object' // && !!shift.candidates[userId]

          // STATUS DA PAUSA (SE HOUVER)
          shift.lastShiftBreak = getShiftPause(shift)

          //
          //
          //

          shift.hora_inicio = String(shift.hora_inicio)
          shift.duration = formatDbTime(shift.periodo)
          shift.floatStartTime = hhmmToFloat(shift.hora_inicio) // Usado para ordenar os horários e no SOS DUTIES CALENDAR
          shift.sortStartTime = durationToMinutes(shift.hora_inicio) // Usado para ordenar os horários
          shift.sortDuration = durationToMinutes(shift.duration)

          shift.shiftDuration = formatFloatToScaleDuration(shift.periodo || 0)

          shift.formattedValue = formatMoney(shift.valor)

          shift.endTime = calculateEndTime(shift.hora_inicio, shift.duration)

          shift.isCanceled = shift.uid_pegou === 0 && shift.status === 'cancelado'

          //
          //
          //

          // shift.isAvailableDuty = shift.uid_pegou === 0
          shift.isUserDuty = shift.uid_pegou !== 0

          //
          // GET DUTY STATUS
          //

          const progressStatus = shift.start_location && shift.end_location ? 'finished' : (shift.start_location ? 'started' : 'unknown')
          shift.shiftStatus = shift.uid_pegou === 0 ? (shift.status === 'cancelado' ? 'cancelado' : 'aberto') : (
            progressStatus === 'started' ? (
              shift.lastShiftBreak.status === 'started' ? 'pausado' : (
                shift.lastShiftBreak.status === 'finished' ? 'retomado' : 'iniciado'
              )
            ) : (
              progressStatus === 'finished' ? 'encerrado' : 'fechado'
            )
          )

          shift.dutyStatus = [`shift__card--${shift.shiftStatus}`]
          if (shift.isExpired) shift.dutyStatus.push('shift__card--vencido')
          if (shift.isUserPassingThisShift) shift.dutyStatus.push('shift__card--passando')
          if (shift.solicitado) shift.dutyStatus.push('shift__card--requested')

          //
          // GET STATUS NAME
          //

          // tem que terminar a pausa para mostrar fim plantão? status? encerrar pausa mesmo que o grupo desativou a opção de intervalo?

          shift.statusName = shift.isUserDuty ? (
            progressStatus === 'started' ? (
              this.group.allowPauseDuringShift ? (
                shift.lastShiftBreak.status === 'started' ? 'Pausado...' : (shift.lastShiftBreak.status === 'finished' ? 'Retomado...' : 'Em andamento...')
              ) : 'Em andamento...'
            ) : (
              progressStatus === 'finished' ? 'Concluído' : 'Assumido'
            )
          ) : (
            shift.status === 'cancelado' ? 'Cancelado' : (
              shift.isExpired ? 'Expirado' : (
                shift.solicitado ? 'Disponível e solicitado por algum profissional' : 'Disponível'
              )
            )
          )

          // INCLUI HORÁRIOS NA LISTA DE HORÁRIOS
          if (!this.dutiesShifts.some(s => s.startTime === shift.hora_inicio))
          {
            this.dutiesShifts.push({
              startTime: shift.hora_inicio,
              floatStartTime: shift.floatStartTime,

              sortStartTime: shift.sortStartTime,
              sortDuration: shift.sortDuration,

              // duration: valueToTime(shift.periodo),
            })
          }

          // INCLUI PLANTONISTA NO CACHE DE USUÁRIOS
          if (shift.uid_pegou !== 0 && !this.cachedUserProfiles.some(p => p.userID === shift.uid_pegou)) shiftsUsers.add(shift.uid_pegou)
          // INCLUI RECEPTOR NO CACHE DE USUÁRIOS
          if (shift.isUserPassingThisShift && !this.cachedUserProfiles.some(p => p.userID === shift.uid_pegando)) shiftsUsers.add(shift.uid_pegando)
          // INCLUI A ESCALA NO CACHE DE ESCALAS
          // if (!!shift.scaleID === true && !this.cachedScales.some(cachedScale => cachedScale.scaleID === shift.scaleID)) shiftsScales.add(shift.scaleID)

          // OUTPUT
          filteredShifts.push(shift)
        })

        //
        // INSERT NEW USERS INTO THE USERS CACHE
        //

        if (shiftsUsers.size > 0)
        {
          const newLoadedUsers = await loadUsers(this.groupUsers, shiftsUsers)

          if (newLoadedUsers.length > 0) newLoadedUsers.forEach(u => { this.cachedUserProfiles.push(u) })
        }

        //
        // INSERT NEW SCALES INTO THE SCALES CACHE/
        //

        /* if (shiftsScales.size > 0)
        {
          const newLoadedScales = await loadScales(this.$route.params.groupID, shiftsScales)

          if (newLoadedScales.length > 0) newLoadedScales.forEach(s => { this.cachedScales.push(s) })
        } */

        //
        // COMPLETE WITH LOADED USERS/SCALES
        //

        const dutiesByDateTime = {}

        filteredShifts.forEach(shift => {
          // DETALHES DO USUÁRIO
          const ownerProfile = shift.isUserDuty ? this.cachedUserProfiles.find(u => u.userID === shift.uid_pegou) : false

          // DETALHES DA ESCALA
          // const scaleData = this.cachedScales.find(scale => scale.scaleID === shift.scaleID)

          // VERIFICA SE O PLANTÃO ESTÁ AGUARDANDO SER ACEITO OU RECUSADO
          if (shift.isUserPassingThisShift)
          {
            const rProfile = this.cachedUserProfiles.find(u => u.userID === shift.uid_pegando)

            shift.receivingPicture = !!rProfile === true && !!rProfile.userImage === true ? rProfile.userImage : userProfileBroken
          }

          // SHIFT SCALE NAME
          shift.scaleName = this.scaleName // !!scaleData === true && !!scaleData.scaleName === true ? scaleData.scaleName /* NOME ATUAL DA ESCALA */ : String(shift.nome || '').trim() /* NOME DA ESCALA NO MOMENTO DA CRIAÇÃO DO PLANTÃO */

          // GET SHIFT COLOR
          if (shift.shiftStatus === 'aberto') shift.bgColor = this.scaleAvailableShiftColor
          if (['fechado', 'iniciado', 'pausado', 'retomado', 'encerrado'].includes(shift.shiftStatus)) shift.bgColor = this.scaleOwnedShiftColor

          // GET DUTY IMAGE
          shift.image = shift.solicitado ? userProfileAvailableAndRequested : userProfileAvailable
          if (shift.isUserDuty) shift.image = ownerProfile && ownerProfile.userImage && ownerProfile.userImage.length > 0 ? ownerProfile.userImage : userProfileBroken
          if (!shift.isUserDuty /* shift.isAvailableDuty */ && (shift.status === 'cancelado' || shift.isExpired)) shift.image = userProfileCancelado // Cancelado ou Expirado

          // GET USER NAME
          shift.userName = shift.isUserDuty ? (ownerProfile && ownerProfile.userName.length > 0 ? ownerProfile.userName : 'Sem nome') : ''

          // OUTPUT
          const startDate = ((shift.dutyStartDateTZ || '') === '+0000' ? moment.utc(shift.data_inicio) : moment(shift.data_inicio)).format('YYYY-MM-DD')
          const startDateTime = `${startDate}_${String(shift.hora_inicio)}`

          if (!!dutiesByDateTime[startDateTime] === false) dutiesByDateTime[startDateTime] = []
          if (!!dutiesByDateTime[startDateTime] === true) dutiesByDateTime[startDateTime].push(shift)

          // ORDER BY DURATION (DEMANDED ON JANUARY 19TH)
          if (!!dutiesByDateTime[startDateTime] === true && dutiesByDateTime[startDateTime].length > 1) {
            dutiesByDateTime[startDateTime].sort((a, b) => a.sortDuration - b.sortDuration)
          }
        })

        //
        //
        //
        // OUTPUT
        //
        //
        //

        // ORDER OR SORT START TIMES
        if (this.dutiesShifts.length > 0)
        {
          this.dutiesShifts.sort((a, b) => {
            // Secondary sort by duration
            if (a.sortStartTime === b.sortStartTime) return a.sortDuration - b.sortDuration

            // Primary sort by start time
            return a.sortStartTime - b.sortStartTime
          })
        }

        // SET
        this.dutiesByDateTime = dutiesByDateTime
        this.hasPlantoes = this.dutiesShifts.length > 0 ? 'yes' : 'no'
      }
    },

    onGroupLoaded() {
      // Aqui você pode chamar o onDutiesUpdate ou outro processamento
      if (this.lastLoadedDuties) {
        this.onDutiesUpdate(this.lastLoadedDuties);
      }
    },
  },
}
